export const TAB_NAME_IMAGE_DETAILS = 'Details';
export const TAB_NAME_IMAGE_EDITOR = 'Image Editor';
export const TAB_NAME_DISPLAY_SETTINGS = 'Display Settings';

export const TAB_IMAGE_DETAILS_SCALE_FACTOR = 0.3;
